import { render, staticRenderFns } from "./_consent-structure.vue?vue&type=template&id=84da66e8"
import script from "./_consent-structure.vue?vue&type=script&lang=js"
export * from "./_consent-structure.vue?vue&type=script&lang=js"
import style0 from "./_consent-structure.vue?vue&type=style&index=0&id=84da66e8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports